import { StyleSheet } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import { DEVICE_WIDTH } from '../../../Constant/size';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;
const orderBtnWidth = (DEVICE_WIDTH - 84) / 4;

export default StyleSheet.create({
    orderItemWrapper: {
        paddingHorizontal: 12,
        paddingTop: 11,
        backgroundColor: baseColor.background2
    },
    itemMergeWrapper: {
        // marginHorizontal: 12,
        marginTop: -1,
        position:'relative',
        backgroundColor: baseColor.white
    },
    mergeUpMargin:{
        height:16
    },
    mergeUnderline:{
        position:'absolute',
        top:0,
        width:DEVICE_WIDTH - 50, 
        height:1,
        alignSelf:'center',
        borderBottomWidth:StyleSheet.hairlineWidth,
        borderColor:baseColor.line
    },
    orderHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        height: 52,
        padding: 16,
        paddingBottom: 12
    },
    orderHeaderLeft: {
        flex: 1,
        flexDirection: 'row'
    },
    orderHeaderRightWrapper: {
        maxWidth: 130,
        height: 20,
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    orderHeaderRight: {
        textAlign: 'right',
        fontSize: 14
    },
    orderHeaderRightArrow: {
        color: baseColor.text2
    },
    orderIconWrapper: {
        overflow: 'hidden',
        justifyContent: 'center',
        alignItems: 'center',
        width: 20,
        height: 20,
        borderRadius: 3
    },
    orderIcon: {
        width: 15,
        height: 15,
        lineHeight: 15,
        textAlign: 'center',
        fontSize: 15,
        color: '#fff'
    },
    orderTitleWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        overflow: 'hidden',
        height: 20,
        marginLeft: 8
    },
    orderTitle: {
        fontSize: 14,
        color: baseColor.text1
    },
    sleepLabel: {       
        borderWidth: 1,
        borderRadius: 2,
        paddingTop: 1,
        paddingBottom: 1,
        paddingLeft: 3,
        paddingRight: 3,
        marginLeft: 5
    },
    sleepLabelText: {
        fontSize: 10
    },
    labelWrap: {
        top: DeviceInfo.isIOS ? 0 : 1,
        // width: 26,
        includeFontPadding: false,
        paddingVertical: 4,
        paddingHorizontal: 1,
        paddingTop: DeviceInfo.isIOS ? 2.5 : 2,
        marginLeft: 4
    },
    orderCheckBtnWrapper: {
        width: 46,
        alignItems: 'center',
        justifyContent: 'center'
    },
    orderCheckBtn: {
        alignItems: 'center',
        justifyContent: 'center',
        width: 20,
        height: 20,
        borderRadius: 10,
        backgroundColor: '#41becd'
    },
    orderCheckIcon: {
        width: 12,
        height: 12,
        fontSize: 12,
        color: '#fff',
        fontWeight: DeviceInfo.isIOS ? '600' : '400'
    },
    orderDeadlineWrapper: {
        flexDirection: 'row',
        backgroundColor: '#fefcec',
        height: 32,
        alignItems: 'center',
        paddingRight: 16,
        paddingLeft: 16,
        marginBottom: 10
    },
    orderDeadlineIcon: {
        top: DeviceInfo.isIOS ? -0.5 : 0.5,
        color: '#ff433c',
        height: 13,
        width: 13,
        fontSize: 13
    },
    onrderDeadlineText: {
        flex: 1,
        marginLeft: 4,
        fontSize: 13,
        color: '#ff433c'
    },
    shareTipWrapper: {
        marginLeft: 0.5,
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 8
    },
    shareTipIcon: {
        width: 12,
        height: 12,
        color: '#00bcd4',
        fontSize: 12
    },
    shareTipText: {
        marginLeft: 4,
        color: baseColor.text3,
        fontSize: 13
    },
    // new ============
    // 卡片内容区
    orderBody: {
        flexDirection: 'row'
    },
    // 卡片内容区内容部分
    orderBodyContent: {
        flex: 1,
        paddingHorizontal: 16,
        paddingBottom: 16
    },
    orderBodyContentInner: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    // 价格区域
    orderBodyRight: {
        position:'relative',
        minWidth: DeviceInfo.isWeb ? 90 : 85,
        alignSelf:'flex-end',
        alignItems: 'flex-end'
    },
    priceBubble:{
        position:'absolute',
        bottom:-20,
        right:0,
        alignItems: 'center',
        justifyContent:'center',
        width:84,
        height:20
    },
    priceBubbleBox:{
        width:84,
        height:20,
        alignItems: 'center',
        justifyContent:'center',
    },
    priceBubbleImage:{
        width:'100%',
        height:'100%'
    },
    // 价格包裹
    orderPriceWrapper: {
        marginTop: DeviceInfo.isIOS ? 2 : 0,
        width: DeviceInfo.isWeb ? 90 : 85,
        textAlign: 'right',
        lineHeight: 16 * 1.25,
        color: baseColor.text1
    },
    // 货币符号
    orderPriceCurrency: {
        fontSize: 12
    },
    // 价格数字
    orderPrice: {
        fontSize: 17
    },
    // 约合$ 666
    orderPriceConvert: {
        fontSize: 12
    },
    disableColor: {
        color: '#bdbdbd'
    },
    disableBg: {
        color: '#bdbdbd'
    },
    // 订单底部
    orderFooter: {
        flexDirection: 'row-reverse',
        alignItems: 'center',
        paddingHorizontal: 12,
        paddingVertical: 10,
        borderTopWidth: StyleSheet.hairlineWidth,
        borderColor: baseColor.line,
        overflow: 'hidden'
    },
      // 按钮
    orderBtn: {
        justifyContent: 'center',
        alignItems: 'center',
        width: orderBtnWidth,
        minWidth: orderBtnWidth,
        height: 28,
        borderRadius: 14,
        marginLeft: 12,
        backgroundColor: '#f8f8f8'
    },
    highlightBtn: {
        color: baseColor.price,
        borderColor: baseColor.price
    },
    normalBtn: {
        color: baseColor.text1,
        borderColor: baseColor.line
    },
    orderBtnText: {
        textAlign: 'center',
        fontSize: 13,
        color: '#424242'
    },
    highlightBtnText: {
        color: '#00bcd4'
    },
    serviceContainer: {
        backgroundColor: '#F2FCFD',
        borderRadius: 6,
        //marginBottom: 16,
        marginHorizontal: 16,
        alignSelf: 'stretch',
        overflow: 'hidden',
        height: 58,
        marginTop: -4,
    },
    serviceContent: {
        paddingHorizontal: 12,
        paddingBottom: 12,
        paddingTop: 10,
        alignSelf: 'stretch',
        height: 58,
    },
    serviceTitleRow: {
        flexDirection: 'row',
        height: 22,
        alignItems: 'flex-start',
        width: '100%',
    },
    serviceTitleText: {
        color: '#333333',
        fontSize: 14,
        fontWeight: 'bold',
        flexShrink: 1,
    },
    serviceDateText: {
        color: '#999999',
        fontSize: 11,
        height: 14,
        paddingLeft: 12,
    },
    serviceDescText: {
        color: '#999999',
        fontSize: 12,
        marginTop: DeviceInfo.isIOS? 2: 1,
    },

    redPoint: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: '#F5200A',
        marginLeft: 4,
    }

});
